import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { AppShell } from "@/components/AppShell";
import { ScreenSpinner } from "@/components/ui/Spinner";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import ForgotPasswordPage from "@/pages/ForgotPassword";
import ResetPasswordPage from "@/pages/ResetPassword";
import VerificarEmailPage from "@/pages/VerificarEmail";
import HomePage from "@/pages/Home";
import RankingsPage from "@/pages/Rankings";
import PerfilPage from "@/pages/Perfil";
import ExtratoPage from "@/pages/Extrato";
import AdminHubPage from "@/pages/admin/AdminHub";
import AdminUsuariosPage from "@/pages/admin/Usuarios";
import AdminExtratoPage from "@/pages/admin/Extrato";
import AdminTorneiosPage from "@/pages/admin/Torneios";
import AdminResultadosPage from "@/pages/admin/Resultados";
import AdminBoasVindasPage from "@/pages/admin/BoasVindas";
import AdminSincronizacaoPage from "@/pages/admin/Sincronizacao";
import PalpitePage from "@/pages/Palpite";
import MeusPalpitesPage from "@/pages/MeusPalpites";
import ProximosTorneiosPage from "@/pages/ProximosTorneios";

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-dvh items-center justify-center">
        <ScreenSpinner />
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verificar-email" element={<VerificarEmailPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  const isAdmin = user.role === "admin" || user.role === "super_admin";

  return (
    <Routes>
      {/* Fora do AppShell e presente TAMBÉM logado: o link do e-mail pode ser
          aberto numa aba que já tem sessão; sem esta rota o catch-all levaria
          para a home e o token nunca seria consumido. */}
      <Route path="/verificar-email" element={<VerificarEmailPage />} />
      <Route element={<AppShell />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/palpite/:tournamentId" element={<PalpitePage />} />
        <Route path="/meus-palpites" element={<MeusPalpitesPage />} />
        <Route path="/proximos-torneios" element={<ProximosTorneiosPage />} />
        <Route path="/rankings" element={<RankingsPage />} />
        <Route path="/perfil" element={<PerfilPage />} />
        <Route path="/extrato" element={<ExtratoPage />} />
        {isAdmin && (
          <>
            <Route path="/admin" element={<AdminHubPage />} />
            <Route path="/admin/usuarios" element={<AdminUsuariosPage />} />
            <Route path="/admin/extrato" element={<AdminExtratoPage />} />
            <Route path="/admin/torneios" element={<AdminTorneiosPage />} />
            <Route
              path="/admin/resultados"
              element={<AdminResultadosPage />}
            />
            <Route
              path="/admin/boas-vindas"
              element={<AdminBoasVindasPage />}
            />
            <Route
              path="/admin/sincronizacao"
              element={<AdminSincronizacaoPage />}
            />
          </>
        )}
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
